import type { SVGProps } from "react";

export function Delete03Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 3.66669L12.5869 10.3501C12.4813 12.0576 12.4285 12.9114 12.0005 13.5253C11.7889 13.8288 11.5165 14.0849 11.2005 14.2774C10.5614 14.6667 9.706 14.6667 7.99513 14.6667C6.28208 14.6667 5.42553 14.6667 4.78603 14.2766C4.46987 14.0838 4.19733 13.8272 3.98579 13.5232C3.55792 12.9084 3.5063 12.0534 3.40307 10.3435L3 3.66669"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path d="M6 7.82336H10" stroke="currentColor" strokeLinecap="round" />
      <path d="M7 10.4362H9" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M2 3.66665H14M10.7037 3.66665L10.2486 2.7278C9.94627 2.10415 9.79507 1.79233 9.53433 1.59785C9.47653 1.55471 9.41527 1.51634 9.3512 1.48311C9.06247 1.33331 8.71593 1.33331 8.02287 1.33331C7.3124 1.33331 6.9572 1.33331 6.66366 1.48939C6.59861 1.52399 6.53653 1.56391 6.47807 1.60876C6.2143 1.81111 6.06696 2.13435 5.77228 2.78082L5.36849 3.66665"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
